import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromDocumentTypes from './doc-admin-reducer';
import { DocumentTypeEffects } from './effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromDocumentTypes.documentTypesFeatureKey, fromDocumentTypes.reducer),
        EffectsModule.forFeature(DocumentTypeEffects)
    ]
})
export class DocumentTypesStoreModule {}
